import { Switch } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import React from "react";

// Empty state for the exterior-order tables, with the branch toggle so a
// user who only sees their own (empty) list can widen it in place.
const WDNoDataDisplay = (props) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <span className="app-icon-tile mb-4 h-14 w-14 rounded-2xl bg-amber-500/15 text-amber-600 dark:text-amber-300">
        <Inventory2OutlinedIcon />
      </span>
      <p className="text-base font-semibold text-[color:var(--app-text)]">
        No Orders Found
      </p>
      <p className="app-muted mt-1 max-w-sm text-sm leading-relaxed">
        {props.branchOrders && (
          <>
            If you think this is a mistake please contact{" "}
            <strong>Help Desk</strong>.
          </>
        )}
        {!props.branchOrders && (
          <>
            If you think this is a mistake please contact{" "}
            <strong>Help Desk</strong> or check <strong>Branch Orders</strong>
            .
          </>
        )}
      </p>
      <label className="app-surface mt-5 inline-flex cursor-pointer items-center rounded-full border pr-4 text-[color:var(--app-text)]">
        <Switch
          checked={props.branchOrders}
          color="warning"
          onChange={() => {
            props.setBranchOrders(!props.branchOrders);
            props.setLoading(true);
          }}
        />
        <p className="text-xs font-medium">My Branch Orders</p>
      </label>
    </div>
  );
};

export default WDNoDataDisplay;
